module.exports = __webpack_public_path__ + "img/home-bg.3fd4b789.png";